import * as buildingActions from 'store/building/actions';
import * as escortsActions from 'store/escorts/actions';
import * as tenantBuildingActions from 'store/tenant-building/actions';
import * as uiMetadataActions from 'store/ui-metadata/actions';
import * as userActions from 'store/user/actions';
import * as visitsActions from 'store/visits/actions';
import * as hostsActions from 'store/hosts/actions';

import { concatMap, filter, map } from 'rxjs/operators';
import { of } from 'rxjs';

import { Epic } from 'redux-observable';
import { RootAction } from 'store/actions';
import { RootDependencies } from 'store/dependencies';
import { RootState } from 'store/reducer';
import { isActionOf } from 'typesafe-actions';
import { showCriticalErrorNotification, showErrorNotification } from './actions';
import { ERROR_PATH, ERR_DEFAULT } from 'shared/consts';

export const handleFailedRequests: Epic<RootAction, RootAction, RootState> = (action$) =>
  action$.pipe(
    filter(
      isActionOf([
        escortsActions.fetchEscorts.failure,
        visitsActions.cancelVisit.failure,
        visitsActions.cancelGroupVisit.failure,
        visitsActions.createVisit.failure,
        visitsActions.updateVisit.failure,
        visitsActions.fetchAllVisits.failure,
        visitsActions.fetchPastVisits.failure,
        visitsActions.fetchUpcomingVisits.failure,
        visitsActions.fetchVisit.failure,
        hostsActions.fetchHosts.failure,
      ]),
    ),
    map((action) =>
      showErrorNotification({
        action: action.type,
        error: action.payload.error,
        errorCode: action.payload.errorCode ?? ERR_DEFAULT,
      }),
    ),
  );

export const handleCriticalErrors: Epic<RootAction, RootAction, RootState, RootDependencies> = (
  action$,
  _state$,
  { navigation },
) =>
  action$.pipe(
    filter(
      isActionOf([
        buildingActions.fetchBuilding.failure,
        tenantBuildingActions.fetchTenantBuilding.failure,
        uiMetadataActions.fetchUiMetadata.failure,
        userActions.externalLogin.failure,
        userActions.getCurrentUser.failure,
        userActions.callActionAfterRefreshTokenTimeout,
      ]),
    ),
    concatMap((action) => {
      navigation.replace(ERROR_PATH);
      return of(
        showCriticalErrorNotification({
          action: action.type,
          error: action.payload.error,
          errorCode: action.payload.errorCode ?? ERR_DEFAULT,
        }),
      );
    }),
  );
